import React, { ReactNode } from 'react';
import { Tabs } from 'antd';
import styles from './COTabs.module.scss';
import { COTabsProps } from 'enums/COTabsEnums';
interface TabItemProps {
  children: React.ReactNode;
  label: unknown;
  key: string;
  active: boolean;
}
export interface TabProps {
  components: TabItemProps[];
  defaultActiveKey?: string;
  activeKey: string;
  handleChange?: (key: string) => void;
  tabBarExtraContent?: { right?: ReactNode };
}

const COTabs: React.FC<TabProps> = ({
  components,
  activeKey,
  handleChange,
  tabBarExtraContent,
}: TabProps) => {
  const { TabPane } = Tabs;

  return (
    <Tabs
      activeKey={activeKey}
      type={COTabsProps.type}
      className={styles.tabsContainer}
      items={components}
      destroyInactiveTabPane
      onChange={handleChange}
      tabBarExtraContent={tabBarExtraContent}
    />
  );
};

export default COTabs;
